import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MobileNav from '../global/Mobile/MobileNav.js';

import  PRETTY from '../../assets/img/logo/PRETTYLASHED.png';
import styled from 'styled-components';



import CartCounter from '../Cart/CartCounter';


import MainPic from '../../assets/Pretty_Lashed/shanise_smile_pic.JPG'
import SubPic1 from '../../assets/Pretty_Lashed/sfp.jpg'
import SubPic2 from '../../assets/Pretty_Lashed/sgoodpic.jpg'

const Row = styled.div`
 {
    display: flex;
    flex-wrap: wrap;
    padding: 0 4px;
  };


` 
  
  /* Create two equal columns that sits next to each other */
const Column = styled.div `
{
    flex: 25%;
    padding: 0 10px;
  }
` 
  
 const Galpic = styled.img`
   {
    margin-top: 8px;
    vertical-align: middle;
   }
 
 ` 



class About extends Component {
  render(){
    return(
        <div>
        <header className="push">
        <div className="nav-container">
          <nav className="primary-nav">
            <Link to="/products">Products</Link>
            <Link to="/styles">Styles</Link>
            <Link to="/gallery">Gallery</Link>
          </nav>
          <MobileNav/>
          <div className="logo">
            <Link to="/" className="logo-link">
              <span className="hide-content">Pretty & Lashed by Shanise</span>
              <div className="big-logo" aria-hidden="true">
              <img alt="Shanise the founder" src={PRETTY} />
              </div>
            </Link>
          </div>
          <nav className="secondary-nav">
            <CartCounter />
          </nav>
        </div>
        </header>
        <div style={{marginTop: 100}}>
        <h2 style={{textAlign: "center"}}>A Message from the founder: </h2>
        <section>
        <Row className="row">
        <Column className="column">
          <Galpic width='300' height='300' src={SubPic2}/>
          <Galpic width='300' height='600' src={MainPic}/>
          <Galpic width='300' height='300' src={SubPic1}/>
        </Column>
        <Column className="column">
          <h5> <strong>"Every Woman Loves Lashes...<br/>Our luxury Lashes are beautiful, comfortable, and affordable.<br/> my brand is about making every woman feel their best..." -- Shanise, founder</strong></h5>
          <p> .Hey My lashed dolls! Welcome to Pretty&Lashed! Our lashes consists of 100% 3D & Siberian Mink. They are affordable, natural looking, and high quality lashes. We brought you many different styles of Lashes. These are definitely must have makeup accessories! Each style has its own unique name. We want you to choose the best style for you! You can wear a different style everyday of the week. Why our company?! Because every girl loves Lashes, beauty is in the eye of the beholder ... we want your eyes to feel comfortable & look glamorous.Thank you for choosing Pretty&Lashed 👁</p>
         </Column>
        </Row>
        </section>
        <div width="10%">
        <Link to="/products" className="btn">
        <strong> Shop </strong> <br/> 
       </Link>
        </div>
        </div>
        </div>
    )

  }

};

export default About;


// WEBPACK FOOTER //
// ./src/components/About/About.js


// WEBPACK FOOTER //
// ./src/components/About/About.js